import { render } from "./InplayUpcomingEventsList.vue?vue&type=template&id=66a36480&scoped=true"
import script from "./InplayUpcomingEventsList.vue?vue&type=script&lang=js"
export * from "./InplayUpcomingEventsList.vue?vue&type=script&lang=js"

import "./InplayUpcomingEventsList.vue?vue&type=style&index=0&id=66a36480&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a36480"]])

export default __exports__